

























import {Vue} from 'vue-property-decorator';

export default class TimestablesSelect extends Vue {
    public selectedTables: number[] = [2,5,6,7,8,9];
    public selection:boolean=false;

    async mounted() {
    }

    toggle(table: number) {
        this.addOrRemove(this.selectedTables, table);
        this.$forceUpdate();
    }

    toggleSelectionMode(){
        this.selection = !this.selection;
        this.$forceUpdate();
    }
    signalAutoStart(){
        this.$emit("startAuto");
    }

    signalCompleted() {
        this.$emit("completed", this.selectedTables);
    }

    isSelected(value:number) : number{
        return this.selectedTables.indexOf(value);
    }

    addOrRemove(array: number[], value: number) {
        var index = array.indexOf(value);

        if (index === -1) {
            array.push(value);
        } else {
            array.splice(index, 1);
        }
    }

}
